import { PayloadAction } from '@reduxjs/toolkit/src/createAction';
import { isArray, isNumber } from 'lodash';
import { TournamentBracketState, UpdateReadyUsersPayload } from './interfaces';

export const updateBracketGameReducer = (
  state: TournamentBracketState,
  action: PayloadAction<UpdateReadyUsersPayload>
): void => {
  if (action.payload) {
    const roundIndex = action.payload?.round;
    const matchIndex = action.payload?.match;
    const gameIndex = action.payload?.game;
    const changes = action.payload?.changes;

    if (!isNumber(roundIndex) || !isNumber(matchIndex) || !isNumber(gameIndex)) {
      return;
    }

    const round = Object.values(state.entities)[roundIndex];
    if (!round) {
      return;
    }

    const match = round.seeds?.[matchIndex];

    if (!match) {
      return;
    }

    const game = match.matchGames?.[gameIndex];

    if (!game) {
      return;
    }

    if (isArray(changes.readyUsers)) {
      game.readyUsers = changes?.readyUsers ?? [];
      game.isJoinGameTimerExpired = changes?.isJoinGameTimerExpired ?? false;
    }
  }
};
